import Service, { getCallApiFunction } from '../service'
import { FeedType } from '@/types/feed'

export type ParamsType = {
  queryTime?: string
  type: FeedType['type']
  preferenceTag: string
  cursorId?: string
}
export type ResponseType = {
  feeds: FeedType[]
  hasMore: boolean
  cursorId?: string
}
class FetchExploreFeedApi extends Service {
  constructor(params: ParamsType) {
    super()
    this.name = 'FETCH_EXPLORE_FEED'
    this.config = {
      url: '/v1/livemall/feed/explore/',
      method: 'GET',
      params,
    }
  }
}
export async function fetchExploreFeed(params: ParamsType): Promise<ResponseType> {
  return getCallApiFunction(new FetchExploreFeedApi(params))
}
